<template>
  <div class="inner-wrap">
		{{$t('linkedIn.pleaseWait')}}
	</div>
</template>

<script>
import api from "@/api";
export default {
    mounted () {
        this.checkAndSendLinkedInCode();
    },
    methods: {
        async checkAndSendLinkedInCode () {
					let query = this.$route.query;
					const ssoProvider = "linkedin";
          let apiObj = {
            sso_provider: ssoProvider,
            sso_token: JSON.stringify({
              grant_type: "authorization_code",
              code: query.code,
              redirect_uri: encodeURI(`${window.location.origin}/linkedin`)
            })
          }
          try {
						this.startLoading()
            const res = await api.getLinkedInAccess(apiObj)
            if (res.data.sid) {
              localStorage.setItem("sid", res.data.sid);
              localStorage.setItem("usr_id", res.data.usr_id);
							this.setLoggedIn(true);
							this.EventBus.$emit('login');
							this.$router.push('/')
						} else {
							this.openToast(this.$t('login.linkedInError'));
							this.$router.push('/login')
						}
          } catch (error) {
            if (error.response.data.status === "validate") {
              this.$router.push("/validate?q=true");
              this.stopLoading();
              return;
            }
            this.EventBus.$emit('error', {
              message: this.$t('login.linkedInError')
            })
						// this.handleError(error);
          } finally {
              this.stopLoading();
          }
				}
    }
}
</script>

<style lang='scss' scoped>
</style>